// Hardcoded sha256sums of launcher executables and pre-installer launchers
export default [
  '020004743a7e0bf6d257ef0833b9ed229204a0112e80a05adfed36d73d7c3d5e',
  '07c658c06b48637409a27fa299dbb447ea2a047db46fa726ea208fda5b8e4cef',
  '2cea36b447a507c793367111a6d891de6fa028440daba22aa24a504034816fbd',
  '36da47090fa642a4ae9bdc28f7ba00fda16dbf363064c96a5132a3f00fe4685d',
  '3e4d8ba370c6369962279d88de7371f9a285a5c1eeced2f3f0507acd8265850a',
  '49ab6cb2e916b1dd62db1f52f1223bc47226a226abd7f1e3d0c9a34351eb23d0',
  '7b6a27fcae09b79db920a402be8d8f69249257b2cc491fb1372b2852aaf67341',
  '8715ddf633d4e4fe9f928cec84b20df1eedb630ef6e3b5d826039f3cbd9268a2',
  '8865dd1b9c902e89a1906159ed097242a49786652dc5a0407d8316e4ef56369b',
  '8edf21633c91a2a360cb3433f9322d3e3cd1fc2f198dc95f64d2e7ea8ff147e9',
  '9041dcc4ebeb326e02744e10391e90fe96d7fb56c9824fa283ec55321cf22455',
  '96bd4957980d4cebee1c5978ce301e5950a50a6dfb40f191d91bc61a6777cd20',
  'a202dea75936f16e11507ec6a666fc86c8d4ac9dec971be5930c470cd090bf23',
  'b590edee17e2a4236b5a179d35f5934ddf9c9075fb09e93a7408f63242394a5f',
  'bf7d1894f90d849619aab940c8d639340c2e745c1411e55d7735ac31398bc384',
  'd89a7d68467b30e0f1375250b7eb8e5e42b37994843f9b2ee6dcc1a53c829ca9',
  '70ea6088a2d7caf1d7f56c4aedc3952b675299611fe09e86c8c1a084bef69554',
  '77b0a566fda117fbb1a03b57dad7811cda575a1bf62e6de7cabb75767fa9453c',
  'f5fd4882635bbe82bd11a83d75bc5ed89685a9fb640936a1ef012fe580b9bf4b',
  'c424cb30ded96ae34ed817053accbd1757391f55c8ebd6000ad811cc0a74a428',
  '833daa64c2e12a1e1e4b168b4f66cbeb0d77afe660ddef13dae0da8ab4d19629',
  '68340acbbd876108bc93212714f869446acc73fe31508832dadd47f90bce8d1f',
  '8e1be37fbdeb5c8ba3dee9e328fbc05d6fa4088e95473500f338ab622d170bb4',
  '1e16248904a8b874a68adb6fae58bd1fa2f88355aca03cae258d710e26230ac1',
  '971bbff3243ca4e49315d1ad7584da82aa1c5201f18bbc98d47b6ee3c745cc2a',
  '532a634d4b08fcea87c7b95080da44690209145bda05c8f9471a568799ab69a6', // packr 1.7 win x64
  '5203a1dba0e980e7a48c5de41ec0182efd238de80e730a39675df4db511b6c5c', // packr 1.7 win x86
  '5db531079e2eab4621dfa37bacf65604dd418530a598306186e5ab0418047701', // packr 1.8 win aarch64
  'c74b0162e98d764dccca1ecc85fa731d8df2799907d07db6ded866b9ac9d2daf', // packr 1.9 win x64
  '43c93ee07307ead4e38e1f5245784162a6b2d1d917e80869b0ca1f5f5e36f7d6', // packr 1.9 win x86
  'b1b5913dbeff9711a891769a9fda8996030a451e6ddded213508803f6dee7a6d', // packr 1.9 win aarch64
  '537ebd020fc2ddfd600f5c7385a755439d9c06307a66077e8bcd718ce8031188', // 2.6.8 x64
  '619baa366436904f7c5dd168c93aa05b56f5572f99719178c00e192bf6059ed1', // 2.6.8 x86
  '2bbc5085062c821fdfbce8f6597283a292be05f8809ed6de5829999426af6b33', // 2.6.8 aarch64
  '2a74c7a094fb59a8afa345c876660aa186825097f09cb471f59f5428432e453c', // 2.6.9 x64
  '00554ec8d5abf1af6ef07ddca288fd6354489629b7c22ea3bc1972e306b3d98b', // 2.6.9 x86
  '62003d77782cf694bc38a35fe2b94f3acda93712b8f1ce6634d4583611682311', // 2.6.9 aarch64
  '550408fa1a377c0caede1a8325c44861028542d46bcecb4959b2799fa9af5a9f', // 2.6.10 x64
  '4060ab9367e254ab18b47d3b08be0b1d660d18943169ca75956a4eacb5c3d02b', // 2.6.10 x86
  '0a871255adf02a9323fd2f8c402560eda8e160edf81a467917d647a459ee6520' // 2.6.10 aarch64
]
